import React from 'react';
import moment from 'moment';
import { connect, ConnectedProps } from 'react-redux';
import { IStore } from '../../../../../../../redux/store';
import { TAnnex6V2Record } from '../../../../../../../redux/app/annex6-v2/@types';
import { TAnnex6V2GroupC2 } from '../../../../../../../redux/app/annex6-v2/groups/group-c';
import Annex6V2TableRows from '../../_elements_v2/Annex6V2TableRows';
import CommaSeparator from '../../../../../../_common/CommaSeparator';
import { vesselSelectors } from 'redux/app/vessel';

type OwnProps = {
    annex6V2Record: TAnnex6V2Record;
    isStrikedOff?: boolean;
    theme?: 'light' | 'dark';
};
type Annex6V2GroupC2PreviewProps = OwnProps & PropsFromRedux;

function Annex6V2GroupC2Preview(props: Annex6V2GroupC2PreviewProps) {
    const record = props.annex6V2Record as TAnnex6V2GroupC2;
    const operationDate = moment(record.selectedDate, 'YYYY-MM-DD').format(
        'DD-MMM-YYYY'
    );
    const { itemC0, itemC2P1, itemC2P2, itemC5P1, itemC5P2 } = record;

    function renderMain() {
        const tableRows = [
            [operationDate, 'C', '3', renderItemP1()],
            [null, null, '4', renderItemP2()],
        ];

        if (record.remarks) {
            tableRows.push([null, null, 'NOTE', record.remarks]);
        }
        if (props.scrubberInfo) {
            tableRows.push([null, null, '-', getScrubberInfo()]);
        }

        return (
            <Annex6V2TableRows
                record={record}
                tableRows={tableRows}
                theme={props.theme}
            />
        );
    }

    function renderItemP1() {
        const { date: smtDate, time: smtTime } = itemC2P1;
        const dateTimeLocal = `${smtDate}T${smtTime}:00${record.timeZone}`;
        const utcTime = moment.utc(dateTimeLocal);

        return (
            <h4 className="font-medium uppercase">
                Completion of{' '}
                <CommaSeparator
                    items={record.itemC5P1.equipmentsUsed.map((equipment) =>
                        equipment.split('_').join(' ')
                    )}
                    lastItemSeperator={' & '}
                />{' '}
                Fuel Changeover upon {itemC0.entryOrExit} ECA on{' '}
                {utcTime.format('HH:mm')} hrs UTC,{' '}
                {utcTime.format('DD-MMM-YYYY')} ({smtTime} SMT on{' '}
                {moment(smtDate, 'YYYY-MM-DD').format('DD-MMM-YYYY')}) at{' '}
                {itemC2P1.latitude} | {itemC2P1.longitude}
            </h4>
        );
    }

    function renderItemP2() {
        return (
            <h4 className="font-medium uppercase">
                <div>
                    Fuel Oil ROB and Sulphur Content at ECA {itemC0.entryOrExit}
                    :
                    <br />
                    Changeover fuel from {itemC5P1.changingFrom.fuelType} (
                    {itemC5P1.changingFrom.sulphurContent}%) to{' '}
                    {itemC5P1.changingTo.fuelType} (
                    {itemC5P1.changingTo.sulphurContent}%)
                    <br />
                    <CommaSeparator
                        items={itemC2P2.tanks.map(
                            (tank) =>
                                `${tank.selectedTank.tankName} - ${tank.fuelOilRob}m³`
                        )}
                        customSeperator={<br />}
                    />
                </div>
            </h4>
        );
    }

    function getScrubberInfo() {
        const { date: smtDate, time: smtTime } = itemC5P2;
        const dateTimeLocal = `${smtDate}T${smtTime}:00${record.timeZone}`;
        const utcTime = moment.utc(dateTimeLocal);

        return (
            <h4 className="font-medium uppercase">
                Scrubber {itemC5P2.mode === 'start' ? 'Started' : 'Stopped'} on{' '}
                {utcTime.format('HH:mm')} hrs UTC,{' '}
                {utcTime.format('DD-MMM-YYYY')} ({smtTime} SMT on{' '}
                {moment(smtDate, 'YYYY-MM-DD').format('DD-MMM-YYYY')}) at{' '}
                {itemC5P2.latitude} | {itemC5P2.longitude}
            </h4>
        );
    }

    return renderMain();
}

function mapStateToProps(store: IStore) {
	const vesselStore = vesselSelectors._getStore(store);
	const scrubberInfo = vesselSelectors.getAnnexVIScrubberInfo(vesselStore);

    return {
        scrubberInfo,
    };
}

const reduxConnector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(Annex6V2GroupC2Preview);
